import { PurchaseOrderItem } from "@/types/purchase";

const previewPurData = {
  "id": "610326094fa6429b857314fd8b6c8fa0",
  "state": 1,
  "sequence": 1598,
  "createdAt": 1770192988669,
  "updatedAt": 1770192988978,
  "createdBy": "010be2bd62fb4a72b8ab41c1eae0427d",
  "updatedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
  "creator": {
    "id": "010be2bd62fb4a72b8ab41c1eae0427d",
    "name1": "",
    "name2": "",
    "avatar": "7553eb31c81a48939144940b1c28a764",
    "areaCode": "+86",
    "mobile": "15500000000",
    "logBookId": "005a46af2a714505a7a7145c18a7ab9f",
    "permissions": null,
    "orgs": null,
    "settings": null,
    "state": 1,
    "createdAt": 1727315278106,
    "createdBy": "e806094105c84cd9adbdba73e1556486",
    "updatedAt": 1753149986408,
    "updatedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
    "creator": null,
    "updater": null
  },
  "updater": {
    "id": "010be2bd62fb4a72b8ab41c1eae0427d",
    "name1": "",
    "name2": "",
    "avatar": "7553eb31c81a48939144940b1c28a764",
    "areaCode": "+86",
    "mobile": "15500000000",
    "logBookId": "005a46af2a714505a7a7145c18a7ab9f",
    "permissions": null,
    "orgs": null,
    "settings": null,
    "state": 1,
    "createdAt": 1727315278106,
    "createdBy": "e806094105c84cd9adbdba73e1556486",
    "updatedAt": 1753149986408,
    "updatedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
    "creator": null,
    "updater": null
  },
  "number": "PO-CNSZ-2026020400319",
  "type": 3,
  "priceId": "",
  "count": 2,
  "amount": "2",
  "rateAmount": "2",
  "orderState": 1,
  "orderTime": 1770192988978,
  "scheduledOrderTime": null,
  "deliveryDeadline": 1754755199999,
  "deliveredQuantity": null,
  "estimateArrivalAt": null,
  "taxRate": "13",
  "spareRate": "0.000000",
  "spareCount": 0,
  "totalCount": 0,
  "inventoryOrders": [],
  "productId": "26d106f179f84fcb8148d9e65d02e097",
  "remark": "",
  "logBookId": "c198f3b3a8a740e09960583434a472d9",
  "docId": "f474a331d14b46738211741fd20bdbbf",
  "order": {
    "id": "8966d0ec8e294954a10570f39204e2ab",
    "state": 1,
    "sequence": 1576,
    "createdAt": 1770192988672,
    "createdBy": "010be2bd62fb4a72b8ab41c1eae0427d",
    "updatedAt": 1770192988672,
    "updatedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
    "creator": null,
    "updater": null,
    "amount": "2",
    "rateAmount": "2",
    "supplierId": "13ca6acbc1c6486b8f1a153046f1f223",
    "remark": null,
    "currency": "2",
    "payMethod": "5ae4892dcb944412807a2682c6a817e0",
    "acceptor": {
      "id": "010be2bd62fb4a72b8ab41c1eae0427d",
      "name1": "",
      "name2": "",
      "avatar": "7553eb31c81a48939144940b1c28a764",
      "areaCode": "+86",
      "mobile": "15500000000",
      "logBookId": "005a46af2a714505a7a7145c18a7ab9f",
      "permissions": null,
      "orgs": null,
      "settings": null,
      "state": 1,
      "createdAt": 1727315278106,
      "createdBy": "e806094105c84cd9adbdba73e1556486",
      "updatedAt": 1753149986408,
      "updatedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
      "creator": null,
      "updater": null
    },
    "acceptedAt": 1770192990384,
    "acceptState": 1,
    "acceptedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
    "receiver": "加多宝食品股份有限公司",
    "receiverContact": "李佳",
    "receiverMobile": "15578754387",
    "receiverAddress": null,
    "inventoryOrders": null,
    "supplier": {
      "id": "13ca6acbc1c6486b8f1a153046f1f223",
      "state": 1,
      "sequence": 1,
      "createdAt": 1730771136772,
      "createdBy": "010be2bd62fb4a72b8ab41c1eae0427d",
      "updatedAt": 1731555282850,
      "updatedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
      "creator": null,
      "updater": null,
      "code": "AB001",
      "name": "加多宝食品股份有限公司",
      "shortName": "JDB",
      "address": "深圳市南山区第一大楼",
      "zipCode": "10000",
      "email": "DB@feng.gmail",
      "contact": "李佳",
      "phone": "0755-200206",
      "mobile": "15578754387",
      "fax": "0755-200206",
      "bank1": "中国农业银行",
      "account1": "9475947619283755838779",
      "swiftCode1": "069276",
      "bank2": "中国工商银行",
      "account2": "9666966793748475923743",
      "swiftCode2": "968887",
      "currency": "2",
      "creditLevel": "1",
      "creditLine": "100000",
      "depositRate": "10",
      "tradeTerm": "c988dd096eb74f15abf2288719a98668",
      "payMethod": "5ae4892dcb944412807a2682c6a817e0",
      "affiliates": "多宝科技",
      "orgId": "de05bc02dd0d4527adf6a74d1f22d654",
      "docId": "3935eae7e49e4ec9a0284a3dcddcbb2b",
      "logBookId": "141cf3720c784c67bd06f7f8fcf54578",
      "country": "CN",
      "billingDays": "30",
      "principal": "吉翁",
      "taxRate": "13",
      "wmsApi": null,
      "thdCode": null
    },
    "items": null
  },
  "printItem": null,
  "quotationRequest": {
    "id": "ad4ff66ce50f4553bbbf03ab47fc77c4",
    "logBookId": "fb1d0a1b069344e8a31c99b5cc0b54fa",
    "requirementItemId": "085d66bf909f44fb90c0c96a7ca77552",
    "count": 2,
    "supplierId": "13ca6acbc1c6486b8f1a153046f1f223",
    "priceId": "1a6b71dbdcba410fa1072f0eaa9b6aed",
    "deadline": 1754755199999,
    "mrd": 1754755199999,
    "status": 3,
    "submitBy": "010be2bd62fb4a72b8ab41c1eae0427d",
    "submitAt": 1770192988044,
    "supplierPrice": "1",
    "supplierTime": 1754755199998,
    "selected": 1,
    "days": 0,
    "mpq": null,
    "spareRate": "0.000000",
    "spareCount": 0,
    "standardCurrency": null,
    "exchangeRate": null,
    "standardPrice": null,
    "remark": null,
    "shelfLife": null,
    "purchaseItem": null,
    "purchaseItemId": "610326094fa6429b857314fd8b6c8fa0",
    "requirementItem": {
      "id": "085d66bf909f44fb90c0c96a7ca77552",
      "state": 1,
      "sequence": 14558,
      "createdAt": 1754026941970,
      "createdBy": "3d9b091f34634bb6b9619725ff02e373",
      "updatedAt": 1770192990903,
      "updatedBy": "SYSTEM",
      "creator": null,
      "updater": null,
      "orderId": "38a7516f3bd947608e1f3da33d9b1df8",
      "productId": "26d106f179f84fcb8148d9e65d02e097",
      "useAmount": "2",
      "bomItemId": "",
      "bomReplId": "",
      "useRepl": 0,
      "maxEstimatedPriceId": "",
      "minEstimatedPriceId": "",
      "maxEstimatedCost": "",
      "minEstimatedCost": "",
      "desc": "",
      "purCount": 2,
      "puredCount": 2,
      "outCount": 0,
      "inCount": null,
      "attritionRate": "0",
      "baseCount": "9857.639908",
      "extCount": "0",
      "supplerId": null,
      "ert": null,
      "quoteRequestCount": 4,
      "quoteRequestReadCount": 1,
      "product": null,
      "quotationRequests": null,
      "quotationRequest": null,
      "requirement": {
        "id": "38a7516f3bd947608e1f3da33d9b1df8",
        "state": 1,
        "sequence": 696,
        "createdAt": 1754026941970,
        "createdBy": "3d9b091f34634bb6b9619725ff02e373",
        "updatedAt": 1754026968735,
        "updatedBy": "3d9b091f34634bb6b9619725ff02e373",
        "creator": null,
        "updater": null,
        "orgId": "4236c5cfc8e940f39396d3b587274307",
        "number": "RQ-CNSZ-2025080100001",
        "sourceType": 3,
        "sourceId": "83b08a91873c40c29c996c04f26385ab",
        "bomHisId": "",
        "productId": "8ab87c9d00254945951803fd81ca38ed",
        "readyCount": 0,
        "estimatedCost": "0",
        "logBookId": "4d92a02e1ade4737bb5d7c868071aa77",
        "mrd": 1754755199999,
        "eps": 1754755200000,
        "desc": "",
        "requireCount": 10100,
        "itemCount": 51,
        "status": 1,
        "quoteItemCount": 49,
        "quoteRequestCount": 118,
        "quoteRequestReadCount": 52,
        "puredItemCount": 0,
        "purItemCount": 49,
        "outStatus": 1,
        "inventoryOrders": null,
        "items": null,
        "saleOrder": null,
        "confirms": null,
        "bom": null,
        "product": null
      },
      "quoteRequestId": "ad4ff66ce50f4553bbbf03ab47fc77c4",
      "deleted": 0,
      "tags": [],
      "purchaseItems": null,
      "inventoryOrders": null,
      "matchKey": null,
      "bomAmount": null,
      "process": null,
      "equotationRequest": null,
      "equotationRequestId": "ad4ff66ce50f4553bbbf03ab47fc77c4"
    },
    "supplier": null,
    "price": {
      "id": "1a6b71dbdcba410fa1072f0eaa9b6aed",
      "state": 1,
      "sequence": 873,
      "createdAt": 1770192968058,
      "createdBy": "010be2bd62fb4a72b8ab41c1eae0427d",
      "updatedAt": 1770192968058,
      "updatedBy": "010be2bd62fb4a72b8ab41c1eae0427d",
      "creator": null,
      "updater": null,
      "supplierId": "13ca6acbc1c6486b8f1a153046f1f223",
      "productId": "26d106f179f84fcb8148d9e65d02e097",
      "price": "1",
      "remark": "",
      "logBookId": "42061679635b4909bb516b7c6f0eb9d4",
      "docId": "f3637e4299e34707a90aeec34a070d41",
      "picDocId": "94613375b0e44408afb235711bd13145",
      "expiredAt": 0,
      "days": null,
      "mpq": null,
      "currency": "2",
      "address": null,
      "spareRate": null,
      "taxRate": null,
      "brand": null,
      "mpn": null,
      "effectiveAt": 1770192968058,
      "shelfLife": null,
      "dcc": null,
      "supplier": null,
      "ladders": null,
      "product": null
    },
    "creator": null,
    "updater": null,
    "submiter": null
  },
  "orderId": "8966d0ec8e294954a10570f39204e2ab",
  "price": null,
  "product": {
    "id": "26d106f179f84fcb8148d9e65d02e097",
    "categoryId": null,
    "code": "421000010",
    "name": "打包带",
    "model": "绿色宽:5分 毛重8公斤 加厚 ROHS",
    "desc": "",
    "uom": "卷",
    "t1": null,
    "t2": null,
    "t3": null,
    "t4": null,
    "t5": null,
    "t6": null,
    "t7": null,
    "t8": null,
    "t9": null,
    "cbm": null,
    "process": null,
    "docId": "f145dedb1026480891267f885887ee11",
    "picDocId": "9bb4aee77f664a65aa9774a8e0b910d1",
    "hsCode": null,
    "preReady": 0,
    "deprecated": null,
    "replacementId": null,
    "category": null,
    "rootCategory": null,
    "replacement": null,
    "locations": null,
    "state": 1,
    "createdAt": 1730776264506,
    "createdBy": "feab4ab6b91e44e3b3e21abe24866998",
    "updatedAt": 1730776264506,
    "updatedBy": "feab4ab6b91e44e3b3e21abe24866998",
    "creator": null,
    "updater": null
  },
  "returnCount": 0,
  "inventoryItems": null,
  "finishState": 0,
  "brand": null,
  "mpn": null,
  "shelfLife": null
} as unknown as PurchaseOrderItem;

export default previewPurData;